module.exports = __webpack_public_path__ + "img/06_bg.dbbce520.png";